import {uniqueId} from 'lodash'

const columns = [
  {
    title: 'User',
    prop: 'username',
    width: 'minmax(150px, 1.5fr)',
    capitalize: true
  },
  {
    title: 'Total replies',
    prop: 'totalReplies'
  },
  {
    title: 'Average response time',
    prop: 'duration',
    type: 'date',
    dateType: 'calcDiff',
    total: 'totalReplies'
  },
  {
    title: 'Total excluded',
    prop: 'totalExcluded'
  }
]

const prefix = 'email_stats_total_column_'
const emailStatsTotalTableColumns = columns.map(col => {
  col.id = uniqueId(prefix)
  return col
})

export default emailStatsTotalTableColumns



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/emailStatsTotalTable.js